// extracted by mini-css-extract-plugin
export default {"content":"ModalCamposRequeridosFicha_content__-vyfN","iconOk":"ModalCamposRequeridosFicha_iconOk__x2pgU","iconClose":"ModalCamposRequeridosFicha_iconClose__CFxJ1"};